import styled from 'styled-components'
import { Button } from '../../../components'

export const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    form {
        background: #565656;
        border-radius: 10px;
        padding: 30px;
        display: flex;
        flex-direction: column;
        gap: 25px;
    }
`

export const Label = styled.p`
    font-size: 14px;
    color: #fff;
    margin-bottom: 3px;
`

export const Input = styled.input`
    height: 40px;
    border-radius: 8px;
    background: #FFFFFF;
    box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.1);
    border: none;
    width: 100%;
    min-width: 350px;
    padding-left: 10px;
`

export const ButtonStyles = styled(Button)`
    margin-top: 25px;
    width: 100%;
`

export const LabelUpload = styled.label`
    cursor: pointer;
    display: flex;
    align-items: center;
    border: 1px dashed #fff;
    border-radius: 5px;
    height: 40px;
    gap: 10px;

    input {
        opacity: 0;
        width: 1px;
    }
`
